import { NavigatorScreenParams } from "@react-navigation/native";
import { StackNavigationProp } from "@react-navigation/stack";
import React from "react";

import { useViewport } from "@/contexts/ViewportContext";

import MobileNavigator, { MobileStackParamList } from "./MobileNavigator";
import WebNavigator, { WebStackParamList } from "./WebNavigator";
import { AddressRoutePaths } from "./stacks/AddressStack";
import { CartRoutePaths } from "./stacks/CartStack";
import { HomeRoutePaths } from "./stacks/HomeStack";
import { OrderRoutePaths } from "./stacks/OrderStack";
import { SettingsRoutePaths } from "./stacks/SettingsStack";

export type RootStackParamList = {
  tabs: NavigatorScreenParams<MobileStackParamList>;
} & WebStackParamList;

export type RootNavigation = StackNavigationProp<RootStackParamList>;

export const RootRoutePaths = {
  homeStack: {
    screens: HomeRoutePaths,
  },
  cartStack: {
    screens: CartRoutePaths,
  },
  addressStack: {
    screens: AddressRoutePaths,
  },
  settingsStack: {
    screens: SettingsRoutePaths,
  },
  orderStack: {
    screens: OrderRoutePaths,
  },
  checkout: "checkout",
  search: "busca",
};

const RootStack = () => {
  const { isWebMode } = useViewport();
  return isWebMode ? <WebNavigator /> : <MobileNavigator />;
};

export default RootStack;
